module.exports = __webpack_public_path__ + "img/video-placeholder-fi.b22bd602.jpg";